import { useState, useEffect } from 'react';
import { registerPanel, closeOtherPanels } from './panelCoordinator';

let listeners = [];
let state = {
  isOpen: false,
  pdfUrl: null,
  pdfTitle: null,
  initialPage: 1,
  fileId: null,
};

const notify = () => listeners.forEach(l => l({ ...state }));

const doOpen = (url, title, page, fileId) => {
  state = { isOpen: true, pdfUrl: url, pdfTitle: title || 'Document', initialPage: page, fileId };
  notify();
};

export const pdfViewer = {
  open: (url, title, page = 1, fileId = null) => {
    // Same PDF already open — do nothing
    if (state.isOpen && state.pdfUrl === url) return;
    const hadOther = closeOtherPanels('pdf');
    if (state.isOpen || hadOther) {
      state = { isOpen: false, pdfUrl: null, pdfTitle: null, initialPage: 1, fileId: null };
      notify();
      setTimeout(() => doOpen(url, title, page, fileId), 350);
      return;
    }
    doOpen(url, title, page, fileId);
  },

  close: () => {
    state = { isOpen: false, pdfUrl: null, pdfTitle: null, initialPage: 1, fileId: null };
    notify();
  },

  goToPage: (page) => {
    state = { ...state, initialPage: page };
    notify();
  },

  getState: () => ({ ...state }),
};

registerPanel('pdf', () => {
  if (!state.isOpen) return false;
  pdfViewer.close();
  return true;
});

export const usePdfViewer = () => {
  const [viewerState, setViewerState] = useState({ ...state });

  useEffect(() => {
    const handler = (s) => setViewerState(s);
    listeners.push(handler);
    return () => {
      listeners = listeners.filter(l => l !== handler);
    };
  }, []);

  return {
    ...viewerState,
    open: pdfViewer.open,
    close: pdfViewer.close,
    goToPage: pdfViewer.goToPage,
  };
};

export default usePdfViewer;
